
(() => {
  let adding = false;

  document.addEventListener('click', async (event) => {
    const size = event.target.closest(
      '[data-quick-add-size="true"]'
    );

    if (!size || size.matches('[disabled], [aria-disabled="true"]')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (adding) return;

    const variantId = size.dataset.variantId;
    if (!variantId) {
      console.warn('Rumor Quick Add: variant ID missing');
      return;
    }

    adding = true;
    size.style.opacity = '0.5';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      if (!response.ok) {
        throw new Error('Unable to add this size to cart');
      }

      document.dispatchEvent(new CustomEvent(
        'dispatch:cart-drawer:refresh',
        { bubbles: true }
      ));

      document.dispatchEvent(new CustomEvent(
        'dispatch:cart-drawer:open'
      ));

    } catch (error) {
      console.error('Rumor Quick Add:', error);
      alert('Sorry, this size could not be added. Please try again.');
    } finally {
      adding = false;
      size.style.opacity = '';
    }
  }, true);
})();
